export const FINANCIAL = {
  FIN_FOOTER_CONTACT_SUBTITLE: 'FINANCIAL_FIN_FOOTER_CONTACT_SUBTITLE',
  FIN_FOOTER_CONTACT_TITLE: 'FINANCIAL_FIN_FOOTER_CONTACT_TITLE',
  FIN_FOOTER_SEND_EMAIL: 'FINANCIAL_FIN_FOOTER_SEND_EMAIL',
  FIN_BOND_TYPE_MTN: 'FINANCIAL_FIN_BOND_TYPE_MTN',
  FIN_BOND_TYPE_OTHER: 'FINANCIAL_FIN_BOND_TYPE_OTHER',
  FIN_DEBT_BANKING_TITLE: 'FINANCIAL_FIN_DEBT_BANKING_TITLE',
  FIN_DEBT_ISSUED_TITLE: 'FINANCIAL_FIN_DEBT_ISSUED_TITLE',
  FIN_DEBT_ISSUED_DESC: 'FINANCIAL_FIN_DEBT_ISSUED_DESC',
  FIN_DEBT_OTHER_TITLE: 'FINANCIAL_FIN_DEBT_OTHER_TITLE',
  FIN_BOND_ISSUED_IN: 'FINANCIAL_FIN_BOND_ISSUED_IN',
  FIN_BOND_LABEL_TYPE: 'FINANCIAL_FIN_BOND_LABEL',
  FIN_BOND_LABEL_TRANSMITION_DATE: 'FINANCIAL_FIN_BOND_LABEL_TRANSMITION_DATE',
  FIN_BOND_LABEL_TERM_DATE: 'FINANCIAL_FIN_BOND_LABEL_TERM_DATE',
  FIN_BOND_LABEL_AMOUNT: 'FINANCIAL_FIN_BOND_LABEL_AMOUNT',
  FIN_BOND_LABEL_COUPON: 'FINANCIAL_FIN_BOND_LABEL_COUPON',
  FIN_BOND_LABEL_LOCATION: 'FINANCIAL_FIN_BOND_LABEL_LOCATION',
  FIN_BOND_LABEL_ISIN: 'FINANCIAL_FIN_BOND_LABEL_ISIN',
  FIN_BOND_LABEL_DOC: 'FINANCIAL_FIN_BOND_LABEL_DOC',
  FIN_DEBT_EMTN_TITLE: 'FINANCIAL_FIN_DEBT_EMTN_TITLE',
  FIN_DEBT_EMTN_DESC: 'FINANCIAL_FIN_DEBT_EMTN_DESC',
  FIN_DEBT_EMTN_EMETTEUR: 'FINANCIAL_FIN_DEBT_EMTN_EMETTEUR',
  FIN_DEBT_EMTN_PLAFOND: 'FINANCIAL_FIN_DEBT_EMTN_PLAFOND',
  FIN_DEBT_EMTN_DEVISES: 'FINANCIAL_FIN_DEBT_EMTN_DEVISES',
  FIN_DEBT_EMTN_AGENTS: 'FINANCIAL_FIN_DEBT_EMTN_AGENTS',
  FIN_DEBT_COM_PAPER_AGENTS: 'FINANCIAL_FIN_DEBT_COM_PAPER_AGENTS',
  FIN_DEBT_COM_PAPER_DEVISES: 'FINANCIAL_FIN_DEBT_COM_PAPER_DEVISES',
  FIN_DEBT_COM_PAPER_EMETTEUR: 'FINANCIAL_FIN_DEBT_COM_PAPER_EMETTEUR',
  FIN_DEBT_COM_PAPER_PLAFOND: 'FINANCIAL_FIN_DEBT_COM_PAPER_PLAFOND',
  FIN_DEBT_COM_PAPER_TITLE: 'FINANCIAL_FIN_DEBT_COM_PAPER_TITLE',
  FIN_DEBT_GREEN_BONDS_DESC: 'FINANCIAL_FIN_DEBT_GREEN_BONDS_DESC',
  FIN_DEBT_GREEN_BONDS_TITLE: 'FINANCIAL_FIN_DEBT_GREEN_BONDS_TITLE',
  FIN_DEBT_HEADER_FITCH: 'FINANCIAL_FIN_DEBT_HEADER_FITCH',
  FIN_DEBT_HEADER_GROSS_DEBT: 'FINANCIAL_FIN_DEBT_HEADER_GROSS_DEBT',
  FIN_DEBT_HEADER_NET_DEBT: 'FINANCIAL_FIN_DEBT_HEADER_NET_DEBT',
  FIN_DEBT_HEADER_RATING: 'FINANCIAL_FIN_DEBT_HEADER_RATING',
  FIN_DEBT_HEADER_RATING_CTA: 'FINANCIAL_FIN_DEBT_HEADER_RATING_CTA',
  FIN_DEBT_HEADER_SP: 'FINANCIAL_FIN_DEBT_HEADER_SP',
  FIN_DEBT_LONG_TERM: 'FINANCIAL_FIN_DEBT_LONG_TERM',
  FIN_DEBT_SHORT_TERM: 'FINANCIAL_FIN_DEBT_SHORT_TERM',
  FIN_DEBT_TITRE_NEGO_AGENTS: 'FINANCIAL_FIN_DEBT_TITRE_NEGO_AGENTS',
  FIN_DEBT_TITRE_NEGO_DEVISES: 'FINANCIAL_FIN_DEBT_TITRE_NEGO_DEVISES',
  FIN_DEBT_TITRE_NEGO_EMETTEUR: 'FINANCIAL_FIN_DEBT_TITRE_NEGO_EMETTEUR',
  FIN_DEBT_TITRE_NEGO_OTHERS: 'FINANCIAL_FIN_DEBT_TITRE_NEGO_OTHERS',
  FIN_DEBT_TITRE_NEGO_PLAFOND: 'FINANCIAL_FIN_DEBT_TITRE_NEGO_PLAFOND',
  FIN_DEBT_TITRE_NEGO_RATING: 'FINANCIAL_FIN_DEBT_TITRE_NEGO_RATING',
  FIN_DEBT_TITRE_NEGO_TITLE: 'FINANCIAL_FIN_DEBT_TITRE_NEGO_TITLE',
  FIN_KEYS_ENVIRONMENT: 'FINANCIAL_FIN_KEYS_ENVIRONMENT',
  FIN_KEYS_FINANCIAL_STRUCTURE: 'FINANCIAL_FIN_KEYS_FINANCIAL_STRUCTURE',
  FIN_KEYS_HUMAN_CAPITAL: 'FINANCIAL_FIN_KEYS_HUMAN_CAPITAL',
  FIN_KEYS_RESULTS: 'FINANCIAL_FIN_KEYS_RESULTS',
  FIN_KEYS_REVENUE_FIGURE: 'FINANCIAL_FIN_KEYS_REVENUE_FIGURE',
  FIN_KEYS_SOCIAL_RESPONSIBILITY: 'FINANCIAL_FIN_KEYS_SOCIAL_RESPONSIBILITY',
  FIN_KEYS_SOCIETY: 'FINANCIAL_FIN_KEYS_SOCIETY',
  FIN_PUBLICATION_BIANNUAL: 'FINANCIAL_FIN_PUBLICATION_BIANNUAL',
  FIN_PUBLICATION_GREEN_BOND: 'FINANCIAL_FIN_PUBLICATION_GREEN_BOND',
  FIN_PUBLICATION_INVESTORS: 'FINANCIAL_FIN_PUBLICATION_INVESTORS',
  FIN_PUBLICATION_REFS: 'FINANCIAL_FIN_PUBLICATION_REFS',
  FIN_PUBLICATION_RSE: 'FINANCIAL_FIN_PUBLICATION_RSE',
  FIN_PUBLICATION_URD: 'FINANCIAL_FIN_PUBLICATION_URD',
  FIN_PUBLICATION_YEARLY_RESULTS: 'FINANCIAL_FIN_PUBLICATION_YEARLY_RESULTS',
  FIN_RATING_DOWNLOAD_FILE: 'FINANCIAL_FIN_RATING_DOWNLOAD_FILE',
  FIN_RATING_FINANCIAL_TAB: 'FINANCIAL_FIN_RATING_FINANCIAL_TAB',
  FIN_RATING_LAST_REVISION: 'FINANCIAL_FIN_RATING_LAST_REVISION',
  FIN_RATING_LONG_TERM: 'FINANCIAL_FIN_RATING_LONG_TERM',
  FIN_RATING_MORE_INFO: 'FINANCIAL_FIN_RATING_MORE_INFO',
  FIN_RATING_OUTLOOK: 'FINANCIAL_FIN_RATING_OUTLOOK',
  FIN_RATING_RSE_TAB: 'FINANCIAL_FIN_RATING_RSE_TAB',
  FIN_RATING_SHORT_TERM: 'FINANCIAL_FIN_RATING_SHORT_TERM',
  FIN_RATING_SUBTITLE: 'FINANCIAL_FIN_RATING_SUBTITLE',
  FIN_READ_TRANSCRIPTION: 'FINANCIAL_FIN_READ_TRANSCRIPTION',
};
